import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useSelector } from "react-redux";
import {
  selectSelectedElement,
  selectSequenceVariables,
} from "../../app/slices/TrainingSlice";
import { MessagePopup } from "../../models/interactions/MessagePopup";
import { useTrainingLocalization } from "../trainingLocalization/TrainingLocalizationHooks";
import { selectCurrentLanguage } from "../../app/slices/TrainingLocalizationSlice";
import RichTextEditor from "../rich_text/RichTextEditor";
import "./MessagePopupPreview.css";

export default function MessagePopupPreview() {
  const messagePopupData = useSelector(selectSelectedElement) as MessagePopup;
  const { getValue, changeValue } = useTrainingLocalization();
  const currentLanguage = useSelector(selectCurrentLanguage);
  const variables = useSelector(selectSequenceVariables);
  const localizedValue = getValue(messagePopupData.message);

  return (
    <div>
      <div className="messagepopuppreview-root">
        <div className="messagepopuppreview-box">
          <div className="messagepopuppreview-box-body">
            <div className="messagepopuppreview-box-text-area">
              <RichTextEditor
                ariaLabel="messagepopuppreview-text-area"
                value={localizedValue}
                onCommit={(nextValue) =>
                  changeValue(messagePopupData.message, nextValue, currentLanguage.shortcode)
                }
                variables={variables}
                debounceMs={250}
                flushOnCleanupKeys={[currentLanguage.shortcode, messagePopupData.message]}
                className="messagepopuppreview-variable-field"
                contentClassName="messagepopuppreview-rich-text"
                warningClassName="messagepopuppreview-warning"
                suggestionsMaxWidth={560}
              />
            </div>
            <div
              aria-label="messagepopuppreview-arrow"
              className="messagepopuppreview-box-body-bottom-button"
            >
              <PlayArrowIcon color="inherit" fontSize="inherit" />
            </div>
          </div>
          <div className="messagepopuppreview-box-bottom" />
        </div>

        <div className="messagepopuppreview-arrow">
          <img aria-label="messagepopuppreview-img" src="arrow.png" alt="" />
        </div>
        <div className="messagepopuppreview-lisa">
          <img src="/lisa.png" alt="" />
        </div>
      </div>
    </div>
  );
}
